var Layout    = require("enyo/Layout"),
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables.js");

module.exports = kind(/** @lends  app.MediaPlayer.ImageViewLayout.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.ImageViewLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var container = this.container,
            appView   = container.app.view,
            $player   = container.getPlayerTech();

        if (!appView.hasNode()
            || !container.hasNode()
            || !$player
            || !$player.hasNode()) {
            return;
        }

        this.maximizedLayout();
    },

    /**
     * Displays the media player at full size. Filling the entire contentRegion
     * of the app layout.
     */
    maximizedLayout: function() {
        var container           = this.container,
            appView             = container.app.view,
            $player             = container.getPlayerTech(),
            headerRegionBounds  = appView.get("headerRegionBounds") || {},
            contentRegionBounds = appView.get("contentRegionBounds") || {},
            headerRegionHeight  = headerRegionBounds.height || 0,
            contentRegionHeight = contentRegionBounds.height || 0,
            contentRegionWidth  = contentRegionBounds.width || 0,
            viewerWidth,
            viewerHeight,
            top                 = 0,
            bottom              = 0,
            left                = 0,
            right               = 0;

        // Switch styles a needed
        container.setAttribute("data-display-mode", "maximized");

        // Viewer dimensions
        viewerWidth  = contentRegionWidth;
        viewerHeight = contentRegionHeight;
        top          += headerRegionHeight;

        if (themeVars.appHeaderFloat === true) {
            viewerHeight -= headerRegionHeight;
        }

        if (!$player.get("supportsSafeArea")) {
            viewerWidth  -= themeVars.safeAreaInsetLeft + themeVars.safeAreaInsetRight;
            viewerHeight -= themeVars.safeAreaInsetBottom;
            left         += themeVars.safeAreaInsetLeft;
            right        += themeVars.safeAreaInsetRight;
            bottom       += themeVars.safeAreaInsetBottom;
        }

        // Apply layout
        container.setBounds({
            width:  viewerWidth,
            height: viewerHeight,
            top:    top,
            right:  bottom,
            bottom: left,
            left:   right
        });
    }

});
